import React from 'react';
import autobind from 'autobind-decorator';
import { connect } from 'react-redux';

import services from 'core/services';
import { PureComponent, GroupBox } from 'core/components';
import { Swiper, SwiperSlide, Icon, List, ListItem, CardContent } from 'core/components/Framework7';

import classes from './styles.module.css';

class Welcome extends PureComponent {
  constructor(props) {
    super(props)
  }

  get initialValue() {
    const { env } = this.props;

    return {
      page: env && env.pages && env.pages.welcome && env.pages.welcome,
      name: (env && env.store && env.store.name && env.store.name) || '',
      shortName: (env && env.store && env.store.shortName && env.store.shortName) || '',
    }
  }

  clickBtnHome() {
    services.storage.set('tour_viewed', true);
    window.location.reload();
  }

  clickBtnLogin() {
    services.storage.set('tour_viewed', true);
    services.storage.set('login_view', true);
    window.location.reload();
  }

  render() {
    const env = this.initialValue;

    return (
      <div className={classes.container}>
        <Swiper pagination
          params={{
            slidesPerView: 1,
            spaceBetween: 0,
            dynamicBullets: true,
          }}
          className={classes.pagePadding}
        >
          {env.page.slides && env.page.slides.map((slide, index) => {
            return (
              <SwiperSlide key={index}>
                <div className={classes.sliderImageContainer}>
                  <span className={`${classes.slideTitle} bulb-text`}>
                    {slide.title}
                  </span>
                  <img src={slide.url} alt={slide.title} />
                  <div className={classes.slideText}>
                    {slide.messages && slide.messages.length > 0 &&
                      <div className={classes.messageContainer}>
                        {slide.messages.map((message, index) => {
                          return <span key={index}>{message}</span>
                        })}
                      </div>
                    }
                  </div>
                </div>
              </SwiperSlide>
            )
          })}
        </Swiper>
        <div className={classes.finishStepButtonContainer}>
          <GroupBox outline className={classes.itemLinks}>
            <CardContent>
              <List noHairlinesMd>
                <ListItem
                  link
                  title="ورود / ثبت نام"
                  onClick={this.clickBtnLogin}
                >
                  <Icon slot="media" icon="mdi-login" />
                </ListItem>
                <ListItem
                  link
                  title="خرید"
                  onClick={this.clickBtnHome}
                >
                  <Icon slot="media" icon="mdi-shopping-outline" />
                </ListItem>
              </List>
            </CardContent>
          </GroupBox>
        </div>
      </div>
    )
  }
}

export default connect(
  state => ({
    env: state.General.env,
  }),
  {

  }
)(autobind(Welcome))
